import { Path, useFormContext } from 'react-hook-form'

import { AbTestsCommonSchema } from 'features/ab-tests/forms/AbTestsCommonForm/abTestsCommonSchema'
import { RowDataVariant } from '../../types'
import { DisabledField, UseDisableDependentInput } from './types'

export const useDisableDependentInput = (): UseDisableDependentInput => {
  const { getValues } = useFormContext<AbTestsCommonSchema>()

  const disabledFields: DisabledField[] = [
    {
      controller: 'prebidStack.auctionDelay.customAuctionDelayEnabled',
      dependent: 'prebidStack.auctionDelay.auctionDelay',
    },
    {
      controller: 'prebidStack.prebidTimeout.customPrebidTimeoutEnabled',
      dependent: 'prebidStack.prebidTimeout.prebidTimeout',
    },
  ]

  const disableInput = (prefix: RowDataVariant['prefix']): boolean => {
    const variantKey = prefix.split('.')[0] as keyof NonNullable<AbTestsCommonSchema['variants']>
    const controllerField: DisabledField | undefined = disabledFields.find(
      field => field.dependent === prefix.split('.').slice(1).join('.'),
    )
    const isDependentFieldDisabled: boolean | undefined =
      controllerField &&
      Boolean(
        getValues(
          `variants.${variantKey}.${controllerField.controller}` as Path<AbTestsCommonSchema>,
        ),
      ) === false &&
      prefix === `${variantKey}.${controllerField?.dependent}`

    return Boolean(isDependentFieldDisabled)
  }

  return {
    isDisabledBy: disableInput,
  }
}
